// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"link-transform"},"children":[{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M13.9998 1.5L13.9998 9.97965L16 7.87416M9.99978 11V2.57906L8 4.6841","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.54545 22.9998H7.25088C4.8991 22.9775 3 21.1953 3 19C3 16.8047 4.8991 15.0225 7.25088 15.0002L9.54545 15M15.2727 19H8.72727M14.4545 15L16.7045 15C19.0769 15 21 16.7909 21 19C21 21.2091 19.0769 23 16.7045 23L14.4545 23","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LinkTransformIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'link-transform',
    ref,
    icon: element,
  },
));

LinkTransformIcon.displayName = 'LinkTransformIcon';

export default LinkTransformIcon;
